import GET_ORDERS from "../graphql/allOrdersForUser.gql";
import { apolloClient } from './apollo'
/**
 * This is only mock api
 */
export function getOrders(serviceman) {
    return apolloClient.mutate({
        mutation: GET_ORDERS,
        variables: {
            serviceman: serviceman
        }
    })
}
